// Shared contract for the post-group-purchase landing page used by both
// the external Stripe Checkout flow (`/group_purchase_complete`) and the
// in-page checkout success path (`UpgradeAction.handleGroupSuccess`).
// Keeping the path, toast keys, and URL composition here ensures both
// flows stay in lockstep — the SSO bounce mechanics legitimately diverge
// (server-side JWT vs client-side POST) and stay at each call site.

export const GROUP_PURCHASE_COMPLETE_TOAST_KEYS = {
  loggedIn: 'manage.groups.purchase_complete.toast_logged_in',
  loggedOut: 'manage.groups.purchase_complete.toast_logged_out',
} as const;

// Returns the manage-tab URL with toast params already baked in. For
// logged-in callers this is the direct destination; for logged-out
// callers this is the `redirect_to` value handed to the SSO flow so the
// toast survives the /authenticate hop.
export const buildGroupPurchaseCompleteUrl = (
  subscriberId: string,
  isAuthed: boolean,
  t: (key: string) => string,
): string => {
  const params = new URLSearchParams({
    tab: 'groups',
    toast: 'success',
    message: t(isAuthed ? GROUP_PURCHASE_COMPLETE_TOAST_KEYS.loggedIn : GROUP_PURCHASE_COMPLETE_TOAST_KEYS.loggedOut),
  });
  return `/subscribe/${subscriberId}/manage?${params.toString()}`;
};
